export const SOLD_BUTTON_ID = 'price-history-sold-button-group' as const;
export const RENTED_BUTTON_ID = 'price-history-rented-button-group' as const;

export type ButtonId = typeof SOLD_BUTTON_ID | typeof RENTED_BUTTON_ID;
